import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  tooltip: {
    background: theme.palette.labraText.tertiary,
    color: theme.palette.text.white,
    minWidth: theme.spacing(12.5),
    padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    borderRadius: theme.spacing(0.4),
    marginTop: theme.spacing(2),
    position: 'relative',
    zIndex: 1,
  },
  divider: {
    background: theme.palette.graphdivider.main,
    width: '100%',
  },
  rank: {
    borderRadius: theme.spacing(0.4),
    padding: theme.spacing(0.25),
    display: 'flex',
    alignItems: 'center',
    textAlign: 'center',
    width: theme.spacing(4),
    color: theme.palette.labraText.primary,
    fontWeight: 600,
    justifyContent: 'center',
  },
  tooltipHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
  },
  tooltipMeta: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
    minWidth: 0,
  },
  date: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.text.white,
    fontFamily: theme.typography.fontFamily,
  },
  linkButton: {
    whiteSpace: 'nowrap',
    marginTop: theme.spacing(-1),
    width: '100%',
    justifyContent: 'left',
    color: theme.palette.button.secondary,
    padding: theme.spacing(1, 0),
    lineHeight: '20px',
    textDecoration: 'underLine',
    textUnderlineOffset: theme.spacing(0.5),
  },
}))
